import { Link } from "react-router-dom";
import { site } from "@/mocks/site";
import { scoops } from "@/mocks/scoops";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  const recent = scoops.slice(0, 3);

  return (
    <footer className="mt-20 bg-secondary-900 text-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-8">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-shield-star-line text-[18px]" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{site.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">{site.intro}</p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-800 text-background-100 transition-colors hover:bg-secondary-700">
                <i className="ri-mail-line" aria-hidden="true"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-800 text-background-100 transition-colors hover:bg-secondary-700">
                <i className="ri-wechat-line" aria-hidden="true"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-800 text-background-100 transition-colors hover:bg-secondary-700">
                <i className="ri-rss-line" aria-hidden="true"></i>
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">浏览</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/" className="text-background-200 transition-colors hover:text-accent-400">首页</Link></li>
              <li><Link to="/scoops" className="text-background-200 transition-colors hover:text-accent-400">爆料库</Link></li>
              <li><Link to="/verify" className="text-background-200 transition-colors hover:text-accent-400">求证中心</Link></li>
              <li><Link to="/about" className="text-background-200 transition-colors hover:text-accent-400">关于我们</Link></li>
              <li><Link to="/contact" className="text-background-200 transition-colors hover:text-accent-400">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">最新档案</h3>
            <ul className="mt-4 space-y-3 text-sm">
              {recent.map((item) => (
                <li key={item.id}>
                  <Link to={`/scoop/${item.id}`} className="line-clamp-2 text-background-200 transition-colors hover:text-accent-400">
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">联系与投稿</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              <li className="flex items-start gap-2">
                <i className="ri-mail-send-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                <span>投稿线索：{site.tipEmail}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-customer-service-2-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                <span>合作与纠错：{site.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                <span>工作时段：周一至周五 10:00–19:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-700 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {site.name} · 所有档案均可追溯来源，转载需注明出处</p>
          <p className="whitespace-nowrap">{site.slogan} · 理性求证，不跟风不臆断</p>
        </div>
      </div>
    </footer>
  );
}